<template>
  <div>
    <myheader
      :backFlag="true"
      :backIntercept="true"
      @childBackEvent="back"
      headTitle="查看详情"
    ></myheader>
    <div class="all_main" style="padding-bottom: 3.4rem">
      <div class="all_content_padding">
        <div class="all_details_content_card" v-if="contractInfo">
          <div class="text16 textcolor333 font_weight_700" style="width: 85%">
            {{ contractInfo.contractName }}
          </div>
          <div class="margin_top_1">
            <div v-for="(item, index) in contractTitle" :key="index">
              <div class="margin_top_1">
                <span
                  class="text12 textcolor999"
                  style="display: inline-block; width: 20%"
                  >{{ contractInfo.titleMap[item] || item }}：</span
                >
                <span class="text12 textcolor999">
                  {{
                    (dateLists.includes(item)
                      ? Tool.dateFormate(contractInfo[item])
                      : contractInfo[item]) || "-"
                  }}</span
                >
              </div>
            </div>
          </div>
          <div
            v-if="contractStatus === 0"
            class="text12 textcolorwhite all_text_center"
            style="
              position: absolute;
              right: 0.5rem;
              top: 0.5rem;
              padding: 0.1rem 0.3rem;
              border-radius: 0.1rem;
            "
            :class="{
              sign_status_ing: contractStatus === 0,
              sign_status_ed: contractStatus === 1,
              sign_status_can: contractStatus === 2,
            }"
          >
            {{ contractInfo.contractStatusText }}
          </div>
          <div v-show="!contractHidden">
            <div v-for="(item, index) in contractTitle1" :key="index">
              <div class="margin_top_1">
                <span
                  class="text12 textcolor999"
                  style="display: inline-block; width: 20%"
                  >{{ contractInfo.titleMap[item] || item }}：</span
                >
                <span class="text12 textcolor999" style="word-break: break-all">
                  {{
                    (dateLists.includes(item)
                      ? Tool.dateFormate(contractInfo[item])
                      : contractInfo[item]) || "-"
                  }}</span
                >
              </div>
            </div>
          </div>
          <div class="horizontal_line margin_top_5"></div>
          <div
            class="all_text_center"
            style="margin: 0.3rem 0 -0.5rem"
            @click="showContractInfo()"
          >
            <img
              src="@/assets/images/down_display.svg"
              :class="{ rotate: !contractHidden }"
            />
          </div>
        </div>
        <div
          v-if="contractStatus === 0"
          class="margin_top_5 display_flex"
          style="margin-left: 0.5rem"
        >
          <span class="text12 textcoloblack font_weight_700">合同签署单位</span>
          <img
            v-if="isShowSelectCorpTips"
            src="@/assets/images/redgantanhao.svg"
            style="
              width: 0.6rem;
              height: 0.6rem;
              object-fit: fill;
              margin-left: 0.5rem;
              margin-top: 0.2rem;
            "
          />
          <span
            v-if="isShowSelectCorpTips"
            class="text12 textcolorRed"
            style="margin-left: 0.2rem"
            >请点击选择一个企业进行签署</span
          >
        </div>
        <div
          v-if="contractStatus !== 0"
          class="text12 textcoloblack font_weight_700 margin_top_5"
          style="margin-left: 0.5rem"
        >
          {{ "签约信息（" + contractCorpLength + "）" }}
        </div>
        <div
          v-if="contractInfo.contractStatus === 0"
          class="all_details_content_card margin_top_2"
        >
          <div
            class="corps"
            :class="{ corpsSelected: corpsSelectIndex === index }"
            v-for="(item, index) in contractInfo.corps"
            :key="index"
            @click="selectCorpsIndex(item, index)"
          >
            <div class="text12 textcolorblack font_weight_700">
              {{ item.corpAlias || item.corpName || "-" }}
            </div>
            <div class="text12 textcolor999 margin_top_3">
              {{ "经办人：" + (item.contactMan || "-") }}
            </div>
            <div class="horizontal_line margin_top_3"></div>
            <div class="margin_top_3" style="display: flex">
              <img
                :src="item.signStatusImg"
                style="width: 0.7rem; height: 0.7rem; margin-top: 0.3rem"
              />
              <span
                class="all_height_line14 text12 textcolor999"
                style="margin-left: 0.3rem; display: inline-block; width: 40%"
                >签名人:</span
              >
              <span
                class="all_height_line14 text12 textcolor333"
                style="display: inline-block; width: 40%"
                >{{ Tool.dateFormate(item.signTime) }}</span
              >
              <span
                class="all_height_line14 text12 textcolor333"
                style="margin-left: 0.2rem"
                >{{ getStatusText(0, item) }}</span
              >
            </div>
            <div
              class="text12 textcolor999 margin_top_3"
              style="padding-left: 1rem"
            >
              {{ item.signerName }}
            </div>
            <div
              class="margin_top_3"
              style="display: flex"
              v-if="contractInfo.bizId != 'QUICK'"
            >
              <img
                :src="item.sealStatusImg"
                style="width: 0.7rem; height: 0.7rem; margin-top: 0.3rem"
              />
              <span
                class="all_height_line14 text12 textcolor999"
                style="margin-left: 0.3rem; display: inline-block; width: 40%"
                >盖章人:</span
              >
              <span
                class="all_height_line14 text12 textcolor333"
                style="display: inline-block; width: 40%"
                >{{ Tool.dateFormate(item.sealTime) }}</span
              >
              <span
                class="all_height_line14 text12 textcolor333"
                style="margin-left: 0.2rem"
                >{{ getStatusText(1, item) }}</span
              >
            </div>
            <div
              class="text12 textcolor999 margin_top_3"
              style="padding-left: 1rem"
              v-if="contractInfo.bizId != 'QUICK'"
            >
              {{ item.sealerName }}
            </div>
          </div>
        </div>
        <div
          v-if="contractInfo.contractStatus !== 0"
          class="all_details_content_card margin_top_2"
        >
          <div
            class="corps"
            :class="{ corpsSelected: corpsSelectIndex === index }"
            v-for="(item, index) in contractInfo.corps"
            :key="index"
            @click="selectCorpsIndex(item, index)"
          >
            <div class="text12 textcolorblack font_weight_700">
              {{ item.corpAlias || item.corpName || "-" }}
            </div>
            <div class="text12 textcolor999 margin_top_3">
              {{ "经办人：" + (item.contactMan || "-") }}
            </div>
            <div class="horizontal_line margin_top_3"></div>
            <div class="margin_top_3" style="display: flex">
              <span
                class="all_height_line14 text12 textcolor999"
                style="display: inline-block; width: 50%"
                >{{
                  "签名人: " + (item.signerName ? item.signerName : "")
                }}</span
              >
              <span
                v-if="contractStatus === 1"
                class="all_height_line14 text12 textcolor333"
                style="display: inline-block; width: 40%"
                >{{ Tool.dateFormate(item.signTime) }}</span
              >
              <img
                v-if="contractStatus === 1"
                src="@/assets/images/selected.svg"
                style="width: 0.7rem; height: 0.7rem; margin-top: 0.3rem"
              />
            </div>
            <div
              class="margin_top_3"
              style="display: flex"
              v-if="contractInfo.bizId != 'QUICK'"
            >
              <span
                class="all_height_line14 text12 textcolor999"
                style="display: inline-block; width: 50%"
                >{{
                  "盖章人: " + (item.sealerName ? item.sealerName : "")
                }}</span
              >
              <span
                v-if="contractStatus === 1"
                class="all_height_line14 text12 textcolor333"
                style="display: inline-block; width: 40%"
                >{{ Tool.dateFormate(item.sealTime) }}</span
              >
              <img
                v-if="contractStatus === 1"
                src="@/assets/images/selected.svg"
                style="width: 0.7rem; height: 0.7rem; margin-top: 0.3rem"
              />
            </div>
          </div>
        </div>
        <div
          class="all_details_content_card margin_top_5 all_text_center"
          @click="jumpBCInfo()"
        >
          <div class="text14 textcolormain">查看区块链存证信息</div>
        </div>
        <div
          v-if="contractInfo.contractStatus !== 0"
          class="all_details_content_card margin_top_5 all_text_center"
          @click="jumpAttachmentInfo()"
        >
          <div class="text14 textcolormain">附件信息</div>
        </div>
        <div
          v-if="contractInfo.contractStatus === 1"
          class="all_details_content_card margin_top_5 all_text_center"
          @click="jumpEvidenceInfo()"
        >
          <div class="text14 textcolormain">存证报告</div>
        </div>
      </div>
      <!-- :class="{bmain_active:(contractInfo.contractStatus>=2||(contractInfo.contractStatus<2&&isMakePermission)),
				backgroundC_main:(contractInfo.contractStatus>=2||(contractInfo.contractStatus<2&&isMakePermission)),
				backgroundC_ccc:(contractInfo.contractStatus<2&&!isMakePermission)}" -->
      <div class="all_tips_bottom_card" v-if="contractStatus === 0">
        <div
          class="margin_bottom_5 display_flex"
          v-if="isShowNoSignOrSealTips !== 0"
        >
          <img
            src="@/assets/images/redgantanhao.svg"
            style="
              width: 0.6rem;
              height: 0.6rem;
              object-fit: fill;
              margin-top: 0.1rem;
            "
          />
          <span class="text12 textcolorRed" style="margin-left: 0.2rem">{{
            isShowNoSignOrSealTips === 1
              ? "请您检查个人签名！"
              : "请您检查该企业的移动证书状态！"
          }}</span>
        </div>
        <div style="display: flex">
          <button
            class="all_button24 text16"
            :class="{
              bmain_active: isPermission,
              backgroundC_main: isPermission,
              backgroundC_ccc: !isPermission,
            }"
            style="display: inline-block; flex: 1"
            @click="openFileClick()"
          >
            签署文件
          </button>
          <img
            @click="showBottom = true"
            src="@/assets/images/menu.svg"
            style="height: 1.4rem; margin: 0.5rem 0.3rem 0.5rem 0.8rem"
          />
        </div>
      </div>
    </div>
    <!-- :style="{'backgroundColor':contractInfo.contractStatus>=2?'#0277FC':(isMakePermission?'#0277FC':'#ccc')}" -->
    <van-popup v-model:show="showBottom" position="bottom">
      <div>
        <div class="horizontal_line"></div>
        <!-- <div class="bottomTooltext text14 textcolor999"
					:class="{backgroundC_white:isChangePermission,bwhite_ative:isChangePermission,backgroundC_ccc:!isChangePermission}"
					@click="selectMakeType(0)">更改</div>
				<div class="horizontal_line"></div> -->
        <div
          class="bottomTooltext text14 textcolor999"
          :class="{
            backgroundC_white: isUrgePermission,
            bwhite_ative: isUrgePermission,
            backgroundC_ccc: !isUrgePermission,
          }"
          @click="selectMakeType(1)"
        >
          催办
        </div>
        <div class="horizontal_line"></div>
        <div
          class="bottomTooltext text14 textcolor999"
          :class="{
            backgroundC_white: isMakePermission,
            bwhite_ative: isMakePermission,
            backgroundC_ccc: !isMakePermission,
          }"
          @click="selectMakeType(2)"
        >
          拒签
        </div>
        <div class="horizontal_line"></div>
        <div style="height: 0.5rem; background-color: #ededed"></div>
        <div class="horizontal_line"></div>
        <div
          class="bottomTooltext all_height_line24 text14 textcolor999"
          @click="showBottom = false"
        >
          取&nbsp;&nbsp;消
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  Dialog
} from 'vant';
import {
  getUserInfo
} from '../../utils/shareRequest'
import {
  getDeviceType,
  fromateDownloadPath,
  startDianjuQuickSign,
} from '../../utils/nativeOtherOperate'
import {
  testDownloadFile
} from '../../utils/nativeTestDemo'
import {
  getLocalCertList,
} from '../../utils/nativeCertSign'
import contractBlockchainCertificateInfoVue from './contractBlockchainCertificateInfo.vue'
export default {
  data() {
    return {
      dateLists: ['expireDate', 'evidenceTime', 'createdTime', 'performStartDate'],
      contractTitle: ['contractCode', 'createdTime'],
      contractTitle1: ['contractMoneyStr', 'evidenceTime',
        'expireDate', 'bizName', 'evidenceCode', 'performStartDate'
      ],
      //合同id
      contractId: '',
      // 企业id
      corpId: '',
      //合同信息
      contractInfo: '',
      //能否操作以传参为主，显示状态以接口数据为主
      contractStatus: 0,
      //合同签约单位数
      contractCorpLength: 0,
      //合同区块链存证
      contractEvidence: [],
      //合同信息是否隐藏
      contractHidden: true,
      //合同上链信息是否隐藏
      contractEvidenceHidden: false,
      showBottom: false,
      //选中操作企业
      corpsSelectIndex: -1,
      //签署企业列表中与企业匹配corps的数据Id
      corpsId: '',
      //签署企业列表中与企业匹配corps的corpId
      corpsCorpId: '',
      //当前合同当前公司是否已签名
      isSigned: false,
      //当前合同当前公司是否已盖章
      isSealed: false,
      //当前用户是否属于当前合同当前公司是否有权限签名
      isSigner: false,
      //当前用户是否属于当前合同当前公司是否有权限盖章
      isSealer: false,
      //当前用户是否属于当前合同当前公司是否有权限修改签名人
      isChangeSigner: false,
      //当前用户是否属于当前合同当前公司是否有权限修改盖章人
      isChangeSealer: false,
      //当前用户当前合同的签署状态 0,"待签约",1,"已签约",2,"已取消"
      //signStatus: 0,
      //是否具有操作（签署，拒签）权限
      isMakePermission: false,
      //企业被拦截是否有签署权限
      isCorpOperatePermission: false,
      //中天合创企业是否有可用签约份数
      isEnableZTHCCountPermission: true,
      //是否显示选择企业提示
      isShowSelectCorpTips: false,
      //是否显示没有签名或没有证书提示0不显示 1签名显示，2 证书显示
      isShowNoSignOrSealTips: 0,
      //
      isPermission: false,
      //是否具有操作（修改签章人）权限
      isChangePermission: false,
      //是否具有催办权限
      isUrgePermission: false,
      //
      appCode: 'ESIGN',
      //
      token: '',
      //
      isUploadFiles: false,
      //
      zthcLockId: '',
    }
  },
  methods: {
    //
    back() {
      if (this.isUploadFiles) {
        this.$store.commit("changeIndexActive", 1)
        this.$router.replace('/home')
      } else {
        this.$router.back()
      }
    },
    //查看合同存证报告
    jumpEvidenceInfo() {
      if (this.contractInfo.contractCode) {
        this.$router.push({
          path: '/contractevidenceinfo',
          query: {
            contractId: this.contractId,
            contractCode: this.contractInfo.contractCode,
          }
        })
      } else {
        this.$Toast('没有合同编号不支持查看！')
      }
    },
    //查看附件信息
    jumpAttachmentInfo() {
      this.$router.push({
        path: '/contractattachpreview',
        query: {
          contractId: this.contractId,
          contractStatus: this.contractStatus
        }
      })
    },
    //查看区块链存证查验详情
    jumpBCInfo() {
      this.$router.push({
        path: '/contractblockchaincertificateinfo',
        query: {
          contractId: this.contractId,
          corpId: this.corpId
        }
      })
    },
    //拒签
    todoDeny() {
      this.$router.push({
        path: '/contractdeny',
        query: {
          contractId: this.contractId,
          corpId: this.corpId
        }
      })
    },
    //催办
    todoUrging() {
      this.$post("/contract/api/urgeContractActors?id=" + this.corpsId).then((res) => {
        if (res.success) {
          this.$Toast('催办成功！')
        } else {
          this.$Toast(res.message || '催办失败！')
        }
      });
    },
    //签署文件
    openFileClick() {
      console.log('openFileClick', this.isPermission)
      if (this.isPermission) {
        // if (getDeviceType() === 'android' || 'harmony' && this.contractInfo.bizId === 'QUICK') {
        // 	this.getAppToken()
        // 	return
        // }
        // this.getAppToken()
        // return
        this.$router.push({
          path: '/contractsignseal',
          query: {
            corpsId: this.corpsId,
            isSigner: this.isSigner,
            isSealer: this.isSealer,
            bizId: this.contractInfo.bizId,
            contractType: this.contractInfo.contractType,
            zthcLockId: this.zthcLockId,
            //contractId: this.contractId,
            //corpId: this.corpId ? this.corpId : this.corpsCorpId,
          }
        })
      }
    },
    //获取esstoken
    getAppToken() {
      this.$store.dispatch(this.$LoadShow, true)
      this.$get('/seal/api/genAppToken', {
        appCode: this.appCode
      }).then((res) => {
        this.$store.dispatch(this.$LoadShow, false)
        if (res.success && res.data) {
          this.token = res.data
          this.startPromiseQuickSign()
          // switch (getDeviceType()) {
          // 	case 'android':
          // 		this.startPromiseQuickSign()
          // 		break
          // 	case 'harmony':
          // 		this.startFlowQuickSign(0)
          // 		break;
          // }
        } else {
          this.$Toast(res.message || res.messageDetail || '获取token失败，请重试!')
        }
      }).catch((err) => {
        console.log('catch--=', err)
        this.$store.dispatch(this.$LoadShow, false)
        this.$Toast('获取token失败，请重试!')
      });
    },
    signleQuickSignFile(file) {
      let that = this
      return new Promise((resolve, reject) => {
        this.$sealp('/api/doc/init?token=' + this.token,
          JSON.stringify({
            resId: this.$store.state.userInfo.staffId + '_' + file.resId,
            docId: file.docId,
            staffId: this.$store.state.userInfo.staffId
          }), this.appCode)
          .then((res) => {
            if (res.success && res.data) {
              let data = res.data
              return new Promise((resolve1, reject1) => {
                let url = window.location.origin +
                  '/seal/api/doc/file/fetch?token=' + that.token
                let fileName = 'document_' + Date.now() + '.pdf'
                switch (getDeviceType()) {
                  case 'android':
                    // case 'ios':
                    let downResult = plus.android.implements(
                      "com.uniapp.pcitc.esign.MyDownFileResult", {
                      "setResult": function (status, result) {
                        console.log(
                          'newDownloadFile-setResult-=',
                          status, result)
                        if (result) {
                          data.filePath = result
                          resolve1(data)
                        } else {
                          reject1('下载文件失败')
                        }
                      }
                    })
                    testDownloadFile(url, fileName, that.appCode, JSON
                      .stringify({
                        fileId: data.fileId,
                        enkey: ''
                      }), downResult)
                    break
                  case 'harmony':
                    harmonyEsign.downFileWithHttpPostToSanBox(that.appCode,
                      url, file.resName, data.fileId, '')
                      .then(res => {
                        if (res) {
                          data.filePath = res
                          resolve1(data)
                        } else {
                          reject1('下载文件失败')
                        }
                      }).catch(err => {
                        console.log('downFileToSanBox-err-=', err)
                        reject1('下载文件失败')
                      })
                    break;
                }
              })
            } else {
              reject1('文件初始化失败')
            }
          }).then((res) => {
            console.log('6-=', res, file)
            resolve([res.filePath, file.docId, res.lockId, res.fileId, file.resName])
          }).catch((err) => {
            console.log('err-=', err)
            reject(err)
          });
      })
    },
    //同步执行
    startFlowQuickSign(index) {
      let that = this
      this.$store.dispatch(this.$LoadShow, true)
      this.$store.dispatch(this.$LoadText, '下载中...')
      let result = []
      this.signleQuickSignFile(this.contractInfo.resList[index]).then(res => {
        if (res) {
          console.log('startFlowQuickSign success', index, res)
          if (index === 0) {
            let positions = ['0', "18579", "28775", "8000", "4000"]
            res[0] = res[0].concat(positions)
          }
          result.push(res)
          index++
          if (index < this.contractInfo.resList.length) {
            this.startFlowQuickSign(index)
          } else {
            that.$store.dispatch(that.$LoadShow, false)
            that.$store.dispatch(that.$LoadText, '加载中...')
            const infos = [that.contractId, that.contractStatus.toString(),
            that.token, that.corpsCorpId
            ]
            startDianjuQuickSign(infos, result)
          }
        } else {
          console.log('startFlowQuickSign失败')
          that.$store.dispatch(that.$LoadShow, false)
          that.$store.dispatch(that.$LoadText, '加载中...')
        }
      }).catch(err => {
        console.log('startFlowQuickSign', err)
        that.$store.dispatch(that.$LoadShow, false)
        that.$store.dispatch(that.$LoadText, '加载中...')
      })
    },
    //异步执行
    startPromiseQuickSign() {
      let that = this
      this.$store.dispatch(this.$LoadShow, true)
      this.$store.dispatch(this.$LoadText, '下载中...')
      let resPromises = []
      this.contractInfo.resList.forEach(file => {
        // const item = this.signleQuickSignFile(file)
        // console.log('resList-=',file,item,typeof item)
        resPromises.push(this.signleQuickSignFile(file))
      })
      Promise.all(resPromises).then(res => {
        that.$store.dispatch(that.$LoadShow, false)
        that.$store.dispatch(that.$LoadText, '加载中...')
        console.log('resPromises-res-1-=', res)
        let positions = ['0', "18579", "28775", "8000", "4000"]
        res[0] = res[0].concat(positions)
        console.log('resPromises-res-2-=', res)
        const infos = [that.contractId, that.contractStatus.toString(),
        that.token, that.corpsCorpId
        ]
        startDianjuQuickSign(infos, res)
      }).catch(err => {
        that.$store.dispatch(that.$LoadShow, false)
        that.$store.dispatch(that.$LoadText, '加载中...')
        console.log('resPromises-err-=', err)
        that.$Toast('下载文件失败，请重试！')
      })
    },
    //
    quickInit() {
      const file = this.contractInfo.resList[0]
      this.$store.dispatch(this.$LoadShow, true)
      this.$sealp('/api/doc/init?token=' + this.token,
        JSON.stringify({
          resId: this.$store.state.userInfo.staffId + '_' + file.resId,
          docId: file.docId,
          staffId: this.$store.state.userInfo.staffId
        }), this.appCode).then((res) => {
          this.$store.dispatch(this.$LoadShow, false)
          if (res.success && res.data) {
            this.newDownloadFile(res.data, file)
          } else {
            this.$store.dispatch(this.$LoadShow, false)
            this.$Toast(res.message || res.messageDetail || '获取文件失败，请重试!')
          }
        }).catch((err) => {
          console.log('catch--=', err)
          this.$store.dispatch(this.$LoadShow, false)
          this.$Toast('获取文件失败，请重试!')
        });
    },
    //
    newDownloadFile(data, file) {
      let that = this
      const url = window.location.origin + '/seal/api/doc/file/fetch?token=' + this.token
      let fileName = 'document_' + Date.now() + '.pdf'
      switch (getDeviceType()) {
        case 'android':
          this.$store.dispatch(this.$LoadShow, true)
          this.$store.dispatch(this.$LoadText, '下载中...')
          let downResult = plus.android.implements("com.uniapp.pcitc.esign.MyDownFileResult", {
            "setResult": function (status, result) {
              console.log('newDownloadFile-setResult-=', status, result)
              that.$store.dispatch(that.$LoadShow, false)
              that.$store.dispatch(that.$LoadText, '加载中...')
              if (result) {
                // startDianjuQuickSign([result,that.contractId, that.contractStatus.toString(),
                // 		that.token, file.docId, data.fileId, data.lockId, that.corpsCorpId
                // 	'1', "10579", "10775", "8000", "4000"])
              } else {
                that.$Toast('下载文件失败，请重试！')
              }
            }
          })
          testDownloadFile(url, fileName, this.appCode, JSON.stringify({
            fileId: data.fileId,
            enkey: ''
          }), downResult)
          break
      }
    },
    //
    downloadFile(data, file) {
      let that = this
      const url = window.location.origin + '/seal/api/doc/file/fetch?token=' + this.token
      switch (getDeviceType()) {
        case 'android':
          //case 'ios':
          let time = Date.now()
          let fileName = '_downloads/document_' + time + '.pdf'
          let aFileName = fromateDownloadPath('downloads/document_' + time + '.pdf')
          this.$store.dispatch(this.$LoadShow, true)
          this.$store.dispatch(this.$LoadText, '下载中...')
          let task = plus.downloader.createDownload(url, {
            method: 'POST',
            data: JSON.stringify({
              fileId: data.fileId,
              enkey: ''
            }),
            filename: fileName,
            verify: false
          }, function (d, status) {
            console.log('downloadFile-=', d, status)
            that.$store.dispatch(that.$LoadShow, false)
            that.$store.dispatch(that.$LoadText, '加载中...')
            if (status === 200) {
              startDianjuQuickSign(aFileName, [that.contractId, that.contractStatus.toString(),
              that.token, file.docId, data.fileId, data.lockId, that.corpsCorpId
              ],
                ['1', "10579", "10775", "8000", "4000"])
            } else {
              that.$Toast('下载文件失败，请重试！')
            }
          })
          task.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
          task.setRequestHeader('X-APP-CODE', this.appCode);
          task.start()
          break
      }
    },
    //下载文件到沙盒中，然后跳转本地打开文本，
    openQuickSignFile() {
      let that = this
      const file = this.contractInfo.resList[0]
      const header = 'Bearer ' + window.localStorage.getItem("Identity_Token")
      const url = window.location.origin + process.env.VUE_APP_API_BASE_URL_MSIGN +
        '/file/api/downloadActFile?fileId=' + file.fileId + '&resName=' + file.resName
      switch (getDeviceType()) {
        case 'android':
        case 'ios':
          let time = Date.now()
          let fileName = '_downloads/document_' + time + '.pdf'
          let aFileName = fromateDownloadPath('downloads/document_' + time + '.pdf')
          this.$store.dispatch(this.$LoadShow, true)
          this.$store.dispatch(this.$LoadText, '下载中...')
          let task = plus.downloader.createDownload(url, {
            filename: fileName,
          }, function (d, status) {
            that.$store.dispatch(that.$LoadShow, false)
            that.$store.dispatch(that.$LoadText, '加载中...')
            if (status === 200) {
              startDianjuQuickSign(aFileName, ['1', "10579", "10775", "8000", "4000"])
            } else {
              that.$Toast('下载文件失败，请重试！')
            }
          })
          task.setRequestHeader('Authorization', header);
          task.start()
          break
        case 'harmony':
          this.$store.dispatch(this.$LoadShow, true)
          this.$store.dispatch(this.$LoadText, '下载中...')
          harmonyEsign.downFileToSanBox(header, url)
            .then(res => {
              that.$store.dispatch(that.$LoadShow, false)
              that.$store.dispatch(that.$LoadText, '加载中...')
              if (res) {

              } else {
                that.$Toast('下载文件失败，请重试！')
              }
            }).catch(err => {
              console.log('downFileToSanBox-err-=', err)
              that.$store.dispatch(that.$LoadShow, false)
              that.$store.dispatch(that.$LoadText, '加载中...')
              that.$Toast('下载文件失败，请重试！')
            })
          break;
      }
    },
    //执行对应操作
    selectMakeType(type) {
      switch (type) {
        case 0: //更改
          if (this.isChangePermission) {
            this.$router.push({
              path: '/contractswitchsignsealer',
              query: {
                contractId: this.contractId,
                corpsCorpId: this.corpsCorpId,
                corpsId: this.corpsId,
                isSigner: this.isChangeSigner,
                isSealer: this.isChangeSealer
              }
            })
          }
          break;
        case 1: //催办
          if (this.isUrgePermission) {
            this.todoUrging()
          }
          break;
        case 2: //拒签
          if (this.isMakePermission) {
            this.todoDeny()
          }
          break;
      }
      this.showBottom = false
    },
    //
    refreshIsPermission() {
      console.log('refreshIsPermission', this.isMakePermission, this.isCorpOperatePermission,
        this.isEnableZTHCCountPermission, this.isShowSelectCorpTips, this.isShowNoSignOrSealTips)
      this.isPermission = this.isMakePermission && this.isCorpOperatePermission &&
        this.isEnableZTHCCountPermission && !this.isShowSelectCorpTips && this.isShowNoSignOrSealTips === 0
      //测试配置
      if (process.env.NODE_ENV === 'development') {
        this.isPermission = true
      }
    },
    //选择默认当前企业
    selectedCorpsIndex(item, index) {
      if (this.contractStatus === 0) {
        this.checkHasSignOrSeal(item)
        //签名盖章权限
        if (item.showSignAction || item.showSealAction) {
          this.corpsId = item.id
          this.corpsCorpId = item.corpId
          this.isSigned = item.hasSigned
          this.isSealed = item.hasSealed
          this.isSigner = item.showSignAction
          this.isSealer = item.showSealAction
          //修改签名人和盖章人权限
          // if (item.canChangeSigner || item.canChangeSealer) {
          // 	this.isChangeSigner = item.canChangeSigner
          // 	this.isChangeSealer = item.canChangeSealer
          // 	this.isChangePermission = true
          // }
          //催办权限
          this.isUrgePermission = item.canUrge
          this.corpsSelectIndex = index
          this.corpId = item.corpId
          this.isMakePermission = true
        }
        if (item.showSealAction && this.contractInfo.bizId === 'ZHTHCH') {
          this.checkZTHCCountEnable()
        } else {
          this.refreshIsPermission()
        }
      }
    },
    //选择签署单位
    selectCorpsIndex(item, index) {
      if (this.contractStatus === 0) {
        this.checkHasSignOrSeal(item)
        //签名盖章权限
        if (item.showSignAction || item.showSealAction) {
          this.corpsId = item.id
          this.corpsCorpId = item.corpId
          this.isSigned = item.hasSigned
          this.isSealed = item.hasSealed
          this.isSigner = item.showSignAction
          this.isSealer = item.showSealAction
          //修改签名人和盖章人权限
          // if (item.canChangeSigner || item.canChangeSealer) {
          // 	this.isChangeSigner = item.canChangeSigner
          // 	this.isChangeSealer = item.canChangeSealer
          // 	this.isChangePermission = true
          // }
          //催办权限
          this.isUrgePermission = item.canUrge
          this.corpsSelectIndex = index
          this.corpId = item.corpId
          this.isMakePermission = true
        }
        if (item.showSealAction && this.contractInfo.bizId === 'ZHTHCH') {
          this.checkZTHCCountEnable()
        } else {
          this.refreshIsPermission()
        }
      }
    },
    //检查是否具有签名或移动证书
    checkHasSignOrSeal(item, flag) {
      //签名
      if (item.showSignAction) {
        if (this.$store.state.userInfo.signature && this.$store.state.userInfo.signature.status === 2) {
          //this.isMakePermission = true
          this.isShowSelectCorpTips = false
          this.isShowNoSignOrSealTips = 0
        } else {
          //this.isMakePermission = false
          this.isShowNoSignOrSealTips = 1
        }
      }
      //证书
      if (item.showSealAction) {
        this.getCorpCertStatus(item).then(res => {
          if (res) {
            this.isShowSelectCorpTips = false
            this.isShowNoSignOrSealTips = 0
          } else {
            this.isShowNoSignOrSealTips = 2
          }
        }).catch(err => {
          //console.log('getCorpCertStatus-err-=', err)
          this.isShowNoSignOrSealTips = 2
        }).finally(() => {
          this.refreshIsPermission()
        })
      }
    },
    //获取选中企业证书可用状态
    getCorpCertStatus(item) {
      let that = this
      return new Promise((resolve, reject) => {
        getLocalCertList(that.$store.state.userInfo.userName).then(res => {
          let status = 0
          //console.log('-getCorpCertStatus-1-certList1', res)
          if (res) {
            let certList = JSON.parse(res)
            if (certList && Array.isArray(certList) && certList.length > 0) {
              certList = certList.filter(cert => {
                let subject = cert.subject
                //ios
                if (window.plus && plus.os.name === 'iOS') {
                  subject = decodeURIComponent(cert.subject.replace(/\\x/g,
                    '%'))
                } else {
                  subject = cert.subject.replace('\\', '')
                }
                return subject.indexOf(item.corpName.trim()) != -1;
              });
              console.log('-getCorpCertStatus-1-certList2', certList)
              if (certList && Array.isArray(certList) && certList.length > 0) {
                //status = 1
                certList.forEach(cert => {
                  //是否需要通过验证证书时间验证证书是否有效
                  let expireDate = null
                  let currentDate = new Date()
                  //ios
                  if (window.plus && plus.os.name === 'Android') {
                    expireDate = new Date(cert.expireDate.replace(' ',
                      'T'))
                  } else if (window.plus && plus.os.name === 'iOS') {
                    expireDate = new Date(this.Tool.getDateForUtc(cert
                      .expireDate))
                    //console.log('ios-expireDate=', expireDate)
                  } else {
                    expireDate = new Date(cert.expireDate)
                  }
                  //console.log('-getCorpCertStatus-3-expireDate', expireDate)
                  if (expireDate && expireDate > currentDate) {
                    status = 1
                  }
                })
              }
            }
          }
          if (status) {
            resolve(status)
          } else {
            reject()
          }
        })
      })
    },
    //
    getDateForUtc(date) {
      return new Date(Date.UTC(parseInt(date.substr(0, 2)) + 2000, parseInt(date.substr(2, 2)),
        parseInt(date.substr(4, 2)), parseInt(date.substr(6, 2)), parseInt(date.substr(8, 2)),
        parseInt(date.substr(10, 2))))
    },
    //获取状态显示文本
    getStatusText(type, item) {
      let text = ''
      if (type === 0) {
        text = '待签名'
        if (item.actStatus != type) {
          text = '已完成'
        }
      } else if (type === 1) {
        text = '待盖章'
      }
      if (item.actStatus === 2) {
        text = '已完成'
      }
      if (item.actStatus === 3) {
        text = '已取消'
      }
      return text
    },
    //获取合同签署文件数量
    getContractFiles() {
      let num = 0
      if (this.contractInfo.contractTextFileName != null) {
        num = 1
      }
      return '（' + (num + this.contractInfo.attachmentFiles.length) + '）';
    },
    //合同详情显示隐藏开关
    showContractInfo() {
      this.contractHidden = !this.contractHidden
    },
    //
    checkCmisCorpEnable() {
      if (this.contractInfo.bizId === 'CMIS' && this.contractStatus === 0) {
        this.$post('/contract/api/checkCorpDisabled/' + this.contractId).then((res) => {
          if (res.success) {
            this.isCorpOperatePermission = true
          } else {
            this.isCorpOperatePermission = false
            this.showMessageInfoAlert(res.message || res.messageDetail)
          }
        }).catch(err => {
          console.log('checkCorpDisabled', err)
          this.$Toast('核查cmis企业报错，请联系管理员！')
        }).finally(() => {
          this.refreshIsPermission()
          this.$store.dispatch(this.$LoadShow, false)
        })
      } else {
        this.isCorpOperatePermission = true
        this.refreshIsPermission()
      }
    },
    //
    checkZTHCCountEnable() {
      this.isEnableZTHCCountPermission = false
      this.$post(`/contract/api/checkCorpAccount/${this.contractId}/${this.corpsCorpId}`).then((res) => {
        if (res.success) {
          this.isEnableZTHCCountPermission = true
          this.zthcLockId = res.data
        } else {
          this.isEnableZTHCCountPermission = false
          this.showMessageInfoAlert(res.message || res.messageDetail)
        }
      }).catch(err => {
        console.log('checkZTHCDisabled', err)
        this.$Toast('核查中天合创可用份数报错，请联系管理员！')
      }).finally(() => {
        this.refreshIsPermission()
        this.$store.dispatch(this.$LoadShow, false)
      })
    },
    //
    showMessageInfoAlert(message, confirmButtonText = '关闭') {
      Dialog.alert({
        title: '提示',
        message: message,
        confirmButtonText: confirmButtonText,
        confirmButtonColor: '#0277FC'
      }).then(() => {
        //this.isMakePermission = false
      });
    },
    //获取合同详情
    getContractDetails() {
      this.$store.dispatch(this.$LoadShow, true)
      this.$post("/contract/api/getContractDetail?contractId=" + this.contractId).then((res) => {
        this.$store.dispatch(this.$LoadShow, false)
        if (res.success && res.data) {
          this.contractInfo = res.data
          this.contractCorpLength = res.data.corps.length
          if (res.data.contractStatus === 0 && res.data.corps && Array.isArray(res.data.corps)) {
            // res.data.corps.forEach((item, index) => {
            // 	item.showSignAction = false
            // 	item.showSealAction = true
            // })
            let filters = res.data.corps.filter(item => {
              return item.showSignAction || item.showSealAction
            })
            //console.log('签名盖章权限----------=', filters)
            res.data.corps.forEach((item, index) => {
              if (filters && Array.isArray(filters) && filters.length === 1) {
                if (filters[0].id === item.id) {
                  this.selectedCorpsIndex(item, index)
                }
              }
              if (item.actStatus === 0) {
                item.signStatusImg = require('@/assets/images/makeing.svg')
                item.sealStatusImg = require('@/assets/images/makeing.svg')
              } else if (item.actStatus === 1) {
                item.signStatusImg = require('@/assets/images/selected.svg')
                item.sealStatusImg = require('@/assets/images/makeing.svg')
              } else {
                item.signStatusImg = require('@/assets/images/selected.svg')
                item.sealStatusImg = require('@/assets/images/selected.svg')
              }
            })
            if (filters && Array.isArray(filters) && filters.length > 1) {
              this.isShowSelectCorpTips = true
            }
          } else {
            this.corpId = res.data.currentCorpId
          }
          switch (this.contractStatus) {
            case 0:
              res.data.contractStatusText = '待签约'
              break;
            case 1:
              res.data.contractStatusText = '已签约'
              break;
            case 2:
              res.data.contractStatusText = '已取消'
              break;
          }
          this.contractInfo = res.data
          this.checkCmisCorpEnable()
          //this.checkZTHCCountEnable()
          this.startCompleteQuickSign()
          this.changeTitlesForContractType(this.contractInfo.contractType)
        } else {
          this.$Toast(res.message || res.messageDetail || '获取合同详情失败！')
        }
      }).catch(err => {
        this.$store.dispatch(this.$LoadShow, false)
        console.log('getContractDetail', err)
        this.$Toast('获取合同详情失败！')
      });
    },
    changeTitlesForContractType(contractType) {
      if (contractType === 10 || contractType === 11) {
        this.contractTitle1 = ['evidenceTime', 'bizName', 'evidenceCode']
      } else if (contractType === 20) {
        this.contractTitle1 = ['contractMemo', 'evidenceTime',
          'expireDate', 'bizName', 'evidenceCode', 'performStartDate'
        ]
      } else if (contractType === 1001) {
        this.contractTitle1 = ['contractMemo', 'createdTime',
          'expireDate', 'evidenceTime', 'bizName', 'evidenceCode',
        ]
      }
    },
    //
    completeQuickSign(contractId, corpId) {
      this.$post('/contract/api/complete', {
        completeType: '0',
        contractId: contractId,
        corpId: corpId,
      }).then((res) => {
        this.$store.dispatch(this.$LoadShow, false)
        if (res.success) {
          this.$Toast('完成签约!')
          this.$store.commit("changeIndexActive", 1)
          this.$router.replace('/home')
        } else {
          this.$Toast(res.message || res.messageDetail || '完成签约失败，请重试!')
        }
      }).catch((error) => {
        this.$store.dispatch(this.$LoadShow, false)
        console.log('/contract/api/complete', error)
        this.$Toast('完成签约失败，请联系管理员!')
      })
    },
    //
    getJsFile(infos, index) {
      const fileName = 'file://' + infos[index][0]
      const urlPath = decodeURIComponent(fileName)
      const url = window.plus.io.convertAbsoluteFileSystem(urlPath)
      let that = this
      return new Promise((resolve, reject) => {
        window.plus.io.resolveLocalFileSystemURL(
          url,
          function (entry) {
            entry.file(function (file) {
              console.log('file内容:', file);
              const reader = new window.plus.io.FileReader();
              reader.onloadend = function (e) {
                console.log('reader内容:', e);
                const base64WithoutPrefix = e.target.result.split(
                  ';base64,').pop();
                const binaryData = atob(base64WithoutPrefix);
                const arrayBuffer = new ArrayBuffer(binaryData.length);
                const uint8Array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < binaryData.length; i++) {
                  uint8Array[i] = binaryData.charCodeAt(i);
                }
                const blob = new Blob([uint8Array], {
                  type: 'application/pdf'
                });
                resolve({
                  content: e.target.result,
                  file: new File([blob], file.name, {
                    type: 'application/pdf'
                  })
                });
              };
              reader.readAsDataURL(file);
            });
          },
          function (e) {
            reject(new Error('文件获取失败: ' + e.message));
            //that.$Toast('文件获取失败: ' + JSON.parse(e));
          }
        );
      });
    },
    //上传pdf文件
    uploadFile(files, infos, index) {
      this.$sealp('/api/doc/sign/save/file?token=' + infos[0][2], {
        docId: infos[index][1],
        segId: '',
        lockId: infos[index][2],
        fileId: infos[index][3],
        corpId: infos[0][3],
        staffId: this.$store.state.userInfo.staffId,
        actType: 1,
        enKey: '',
        file: files.file
      }, this.appCode, 'form').then((res) => {
        if (res.success && res.data) {
          if (index === infos.length - 1) {
            this.completeQuickSign(infos[0][0], infos[0][3])
          } else {
            index++
            this.startGetJsFile(infos, index)
          }
        } else {
          this.$store.dispatch(this.$LoadShow, false)
          this.$Toast(res.message || res.messageDetail || '上传文件失败，请重试!')
        }
      }).catch((err) => {
        console.log('catch--=', err)
        this.$store.dispatch(this.$LoadShow, false)
        this.$Toast('上传文件失败，请重试!')
      });
    },
    //
    startGetJsFile(infos, index) {
      this.getJsFile(infos, index).then(file => {
        console.log('--contractDetails-getJsFile', file)
        this.uploadFile(file, infos, index)
      }).catch(err => {
        this.$store.dispatch(this.$LoadShow, false)
        console.log('getJsFile', err)
      })
    },
    //安卓速签提交开始
    startCompleteQuickSign() {
      if (this.$store.state.quickSignContractDetails) {
        const info = this.$store.state.quickSignContractDetails
        this.$store.dispatch('actionQuickSignContractDetails', '')
        const infos = JSON.parse(info)
        if (infos[1]) {
          this.isUploadFiles = true
          this.$store.dispatch(this.$LoadShow, true)
          let index = 1
          this.startGetJsFile(infos, index)
        }
        return
      }
    },
    //鸿蒙遍历上传签署文件
    // const infos = [that.contractId, that.contractStatus.toString(),
    // 	that.token, that.corpsCorpId
    // ]
    startUploadFile(infos, index) {
      const binaryData = atob(infos[index][4]);
      const arrayBuffer = new ArrayBuffer(binaryData.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
      }
      const blob = new Blob([uint8Array], {
        type: 'application/pdf'
      });
      const files = new File([blob], infos[index][3], {
        type: 'application/pdf'
      })
      this.$sealp('/api/doc/sign/save/file?token=' + this.token, {
        docId: infos[index][1],
        segId: '',
        lockId: infos[index][2],
        fileId: infos[index][3],
        corpId: this.corpsCorpId,
        staffId: this.$store.state.userInfo.staffId,
        actType: 1,
        enKey: '',
        file: files
      }, this.appCode, 'form').then((res) => {
        if (res.success && res.data) {
          if (index === infos.length - 1) {
            this.completeQuickSign(this.contractId, this.corpsCorpId)
          } else {
            index++
            this.startUploadFile(infos, index)
          }
        } else {
          this.$store.dispatch(this.$LoadShow, false)
          this.$Toast(res.message || res.messageDetail || '上传文件失败，请重试!')
        }
      }).catch((err) => {
        console.log('catch--=', err)
        this.$store.dispatch(this.$LoadShow, false)
        this.$Toast('上传文件失败，请重试!')
      });
    },
    //鸿蒙速签提交结果
    onQuickSignResult(result) {
      console.log('onQuickSignResult', result)
      if (result && Array.isArray(result) && result.length > 0) {
        this.$store.dispatch(this.$LoadShow, true)
        this.startUploadFile(result, 0)
      } else {
        this.$Toast('提交失败，请重试!')
      }
    },
    //初始化
    init() {
      this.contractId = this.$route.query.contractId
      this.contractStatus = parseInt(this.$route.query.contractStatus)
      this.getContractDetails()
    },
  },
  mounted() {
    getUserInfo()
    this.init()
  },
  created() {
    window.onQuickSignResult = this.onQuickSignResult
  }
}
</script>

<style scoped lang="scss">
@import "../../styles/global.css";

.file {
  width: 100%;
  height: 2rem;
  border: 1px solid #ccc;
  border-radius: 0.1rem;
  display: flex;
  padding: 0 0.5rem;
}

.corps {
  padding: 0.5rem;
  background-color: #f2f2f2;
  border-radius: 0.1rem;
  margin-bottom: 1rem;
}

.corps:last-child {
  margin-bottom: 0;
}

.corpsSelected {
  background-color: #81d3f825;
  border: 1px solid #02a7f0;
}

// 上链完成
.uploadCompleted {
  background-color: #d7d7d7;
  border-radius: 0.1rem;
}
</style>